import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { ActivatedRoute, Router } from '@angular/router';
var CasePracticeInfluenceMainComponent = (function () {
    function CasePracticeInfluenceMainComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.step = 1;
        this.assetsRoute = '../../assets';
        this.theme = 'influence-one';
        this.progress = 0;
        this.currentProgress = 0;
        this.flag = false;
    }
    CasePracticeInfluenceMainComponent.prototype.onPopState = function () {
        if (this.audio) {
            this.audio.pause();
        }
    };
    CasePracticeInfluenceMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var that = this;
        this.userType = window.sessionStorage.getItem('userType');
        this.informationStatus = 'hideInformation';
        this.normalStatus = 'hidePeople';
        this.acceptStatus = 'hidePeople';
        this.awkwardStatus = 'hidePeople';
        this.indifferentStatus = 'hidePeople';
        this.womanStatus = 'hidePeople';
        this.womanMessage = 'hideBox';
        this.resistStatus = 'hidePeople';
        this.boxOneStatus = 'hideBox';
        this.boxTwoStatus = 'hideBox';
        this.optionWrapStatus = 'hideOptionWrap';
        this.hintStatus = 'hideHint';
        this.buttonStatus = 'hideBox';
        this.reviewBtnStatus = 'hideBox';
        this.telephoneStatus = 'hideBox';
        this.soldShow = false;
        this.clickable = false;
        this.currentFakeWord = '';
        this.msgCharacter = 0;
        this.optionClick = false;
        this.optionOnClick = false;
        this.optionClickTimeout = null;
        this.letterClick = false;
        this.currentContainer = null;
        this.audio = null;
        this.practiceMetaId = Number(window.sessionStorage.getItem('visitorPracticeMetaId'));
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        this.route.params.subscribe(function (params) {
            _this.practiceId = params['practiceId'];
            _this.exerciseId = params['exerciseId'];
            console.log(_this.exerciseId);
            _this.learningPathId = params['learningPathId'];
            _this.exerciseMetaId = $('#exerciseMetaId').val();
            _this.apiService.ajax({
                'type': 'get',
                'url': '/api/exercises/' + _this.exerciseId
            }).subscribe(function (result) {
                _this.questions = result.questions;
                _this.conversationHistory = [];
                _this.currentCaseId = result.id;
                //全局变量初始化为 null
                window['exercises' + _this.currentCaseId] = null;
                _this.exerciseInit();
            });
            /*this.questions = this.getMockData().questions;
            this.conversationHistory = [];
            this.currentCaseId = this.getMockData().id;
            this.exerciseInit();
            console.log(this.questions);
            */
            //判断传过去的主题
            if (_this.exerciseMetaId == 71) {
                _this.theme = 'influence-one';
            }
            _this.apiService.getLearningPathMetaIdByPathId(_this.learningPathId.toString()).subscribe(function (res) {
                var that = _this;
                if (res.data) {
                    that.getLearningPathSubItems(res.data).then(function (result) {
                        that.practiceMetaId = result.subItems[2].practiceMetaId;
                    });
                }
            });
        });
    };
    //查询能力模块信息
    CasePracticeInfluenceMainComponent.prototype.getLearningPathSubItems = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/learningpathes/' + learningPathMetaId,
        }).toPromise();
    };
    CasePracticeInfluenceMainComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        document.oncontextmenu = function (e) {
            e.preventDefault();
        };
    };
    //获取进度
    CasePracticeInfluenceMainComponent.prototype.getProgress = function () {
        var _this = this;
        this.apiService.getProgress(this.exerciseId).subscribe(function (result) {
            console.log(result);
            _this.currentProgress = result.progress;
            _this.progress = result.progress;
            console.log(_this.progress);
        });
    };
    /*  逻辑F
    step 0: 初始化, 用户再次点击屏幕, => step 2
    step 1: 显示我说的话, 再次点击 => step 2
    step 2: 显示当前节点秦飞说的话再次点击，如果有导师提示语 => step 3 如果没有导师提示语并有选项 => step 4 如果没有导师提示语并没有选项 => step 5
    step 3: 显示导师提示语, 再次点击 如果有选项 => step 4 如果没有选项 => step 5
    step 4: 显示选项, 点击选项后 => step 1
    step 5; 决策树终止，显示生成报告按钮
  */
    CasePracticeInfluenceMainComponent.prototype.screenClick = function () {
        var that = this, 
        /*  判断逻辑
          *  当用户为访客进行情景模拟到特定断点时，
          *  将当前点评文字和breakWordArr里的元素进行匹配，
          *  如果匹配成功breakTarget为数组下标，弹出注册提示框
          *  如果匹配失败breakTarget为-1，继续进行模拟
          */
        breakTarget = -1, //访客情景模拟中断标签
        breakWordArr = [
            '老秦很忙，客套时间不要太长，赶快说明来访目的吧！',
            '终于进入正题！想想该如何跟对方沟通你的难题。',
            '一味给对方戴高帽并不可取，赶紧探讨具体问题吧。',
            '在对方看来，你的问题优先级不高，怎么破？',
            '你急得焦头烂额，对方却并不重视。该怎么让对方意识到问题的严重性呢？'
        ];
        if (this.letterClick) {
            this.showFullText(this.currentContainer);
            return;
        }
        //季经理头像特殊处理
        if (this.boxOneStatus == 'showBox' && this.womanStatus == 'showPeople') {
            this.boxOneStatus = 'hideBox';
            this.womanMessage = 'showBox';
            return false;
        }
        else {
            this.womanMessage = 'hideBox';
        }
        if (!this.clickable) {
            console.log('clickable');
            return;
        }
        // console.log('2:'+this.step);
        // console.log(that.currentWord);
        if (this.step == 0) {
            this.clickable = false;
            this.informationStatus = 'hideInformation';
            setTimeout(function () {
                that.peopleConversion(that.currentExpression, 1);
                that.boxTwoStatus = 'showBox';
                setTimeout(function () {
                    that.msgCharacter = 0;
                    that.getLetterByLetter($('#talkBoxContent2'));
                }, 200);
                that.conversationHistory.push({
                    'role': '秦飞',
                    'comment': that.currentWord
                });
                setTimeout(function () {
                    that.step = 2;
                    that.clickable = true;
                }, 1700);
            }, 500);
        }
        else if (this.step == 1) {
            this.clickable = false;
            this.oldExpression = this.currentExpression;
            this.currentExpression = this.currentItem.expression;
            if (this.additionType == 0) {
                this.boxOneStatus = 'hideBox';
                setTimeout(function () {
                    $('#talkBoxContent1').html('');
                }, 200);
                if (this.oldExpression != this.currentExpression) {
                    this.peopleConversion(this.oldExpression, 0);
                }
            }
            else if (this.additionType == 1) {
                this.telephoneStatus = 'hideBox';
                $('#play').fadeOut(200);
                $('#playWrap').fadeOut(200);
            }
            else if (this.additionType == 2) {
                this.boxOneStatus = 'hideBox';
                $('#talkBoxContent1').html('');
                this.peopleConversion('季宁', 0);
            }
            else if (this.additionType == 3) {
                this.telephoneStatus = 'hideBox';
                this.soldShow = false;
            }
            setTimeout(function () {
                that.currentWord = that.currentItem.description;
                that.currentRole = '秦飞';
                that.conversationHistory.push({
                    'role': that.currentRole,
                    'comment': that.currentWord
                });
                that.currentFakeWord = that.currentWord;
                that.boxTwoStatus = 'showBox';
                setTimeout(function () {
                    that.msgCharacter = 0;
                    that.getLetterByLetter($('#talkBoxContent2'));
                }, 200);
                if (that.oldExpression != that.currentExpression && that.additionType == 0 || that.additionType == 1 || that.additionType == 2 || that.additionType == 3) {
                    that.peopleConversion(that.currentExpression, 1);
                }
                setTimeout(function () {
                    that.step = 2;
                    that.clickable = true;
                }, 1700);
            }, 500);
        }
        else if (this.step == 2) {
            this.clickable = false;
            // console.log(this.userType+';'+that.currentWord);
            this.boxTwoStatus = 'hideBox';
            setTimeout(function () {
                $('#talkBoxContent2').html('');
            }, 200);
            this.currentHint = this.currentItem.directorComment;
            if (this.currentHint != '') {
                this.currentRole = '导师';
                setTimeout(function () {
                    that.currentWord = that.currentHint;
                    that.currentFakeWord = that.currentWord;
                    that.hintStatus = 'showHint';
                    setTimeout(function () {
                        setTimeout(function () {
                            that.step = 3;
                            that.clickable = true;
                        }, 1000);
                        that.conversationHistory.push({
                            'role': '导师点评',
                            'comment': that.currentWord
                        });
                    }, 250);
                }, 500);
            }
            else {
                this.currentOptions = this.currentItem.options.sort(function () {
                    return 0.5 - Math.random();
                });
                if (this.currentOptions.length > 0) {
                    this.peopleConversion(this.currentExpression, 0);
                    setTimeout(function () {
                        that.optionWrapStatus = 'showOptionWrap';
                        setTimeout(function () {
                            that.step = 4;
                        }, 200);
                    }, 500);
                }
                else {
                    this.buttonStatus = 'showBox';
                    setTimeout(function () {
                        that.step = 5;
                        that.clickable = false;
                    }, 200);
                    console.log('end1');
                }
            }
        }
        else if (this.step == 3) {
            this.clickable = false;
            breakTarget = $.inArray(that.currentWord, breakWordArr);
            // console.log(breakTarget);
            if (this.userType && breakTarget !== -1) {
                $('#shade2').fadeIn();
                $('#tip2').fadeIn();
            }
            else {
                this.currentOptions = this.currentItem.options.sort(function () {
                    return 0.5 - Math.random();
                });
                if (this.currentOptions.length > 0) {
                    this.hintStatus = 'hideHint';
                    setTimeout(function () {
                        that.optionWrapStatus = 'showOptionWrap';
                        that.peopleConversion(that.currentExpression, 0);
                        setTimeout(function () {
                            that.step = 4;
                        }, 500);
                    }, 500);
                }
                else {
                    setTimeout(function () {
                        that.buttonStatus = 'showBox';
                        that.currentProgress = 100;
                        setTimeout(function () {
                            that.step = 5;
                            that.clickable = false;
                        }, 500);
                        console.log('end2');
                        console.log(that.exerciseId);
                        // this.currentProgress=100
                        // that.currentProgress=100
                        console.log(this.currentProgress);
                        that.apiService.saveProgress({ exerciseId: that.exerciseId, progress: 100 }).subscribe(function (result) {
                            console.log(result);
                        });
                    }, 500);
                }
            }
        }
        else if (this.step == 11) {
            this.clickable = false;
            this.boxOneStatus = 'showBox';
            setTimeout(function () {
                that.msgCharacter = 0;
                that.getLetterByLetter($('#talkBoxContent1'));
            }, 200);
            setTimeout(function () {
                that.step = 12;
                that.clickable = true;
            }, 1700);
        }
        else if (this.step == 12) {
            this.clickable = false;
            this.boxOneStatus = 'hideBox';
            setTimeout(function () {
                $('#talkBoxContent1').html('');
            }, 200);
            $('#play').fadeIn(200);
            $('#playWrap').fadeIn(200);
        }
        else if (this.step == 21) {
            this.clickable = false;
            this.boxOneStatus = 'showBox';
            setTimeout(function () {
                that.msgCharacter = 0;
                that.getLetterByLetter($('#talkBoxContent1'));
            }, 200);
            setTimeout(function () {
                that.step = 22;
                that.clickable = true;
            }, 1700);
        }
        else if (this.step == 22) {
            this.clickable = false;
            this.boxOneStatus = 'hideBox';
            $('#talkBoxContent1').html('');
            this.soldShow = true;
            setTimeout(function () {
                that.clickable = true;
                that.step = 1;
                that.additionType = 3;
            }, 1500);
        }
    };
    CasePracticeInfluenceMainComponent.prototype.exerciseInit = function () {
        this.getProgress(); //获取进度
        var that = this;
        this.currentFakeWord = '';
        this.msgCharacter = 0;
        this.itemTemp = this.questions[0];
        do {
            this.optionsTemp = this.itemTemp.options;
            this.optionIndexTemp = this.getSelectedOptionIndex(this.optionsTemp);
            if (this.optionIndexTemp != -1) {
                this.nextQuestionIdTemp = this.optionsTemp[this.optionIndexTemp].nextQuestionId;
                this.conversationHistory.push({
                    'role': '秦飞',
                    'comment': this.itemTemp.description
                });
                if (this.itemTemp.directorComment != '') {
                    this.conversationHistory.push({
                        'role': '导师点评',
                        'comment': this.itemTemp.directorComment
                    });
                }
                this.conversationHistory.push({
                    'role': '我',
                    'comment': this.optionsTemp[this.optionIndexTemp].description
                });
                this.setItemTemp(this.nextQuestionIdTemp);
            }
            else {
                break;
            }
        } while (true);
        if (this.userType) {
            this.conversationHistory.length = 0;
        }
        if (this.conversationHistory.length != 0) {
            this.step = 1;
            var addition = this.oldItemTemp.options[this.oldOptionIndexTemp].addition;
            if (addition == '') {
                this.additionType = 0;
            }
            else if (addition == '语音播放') {
                this.additionType = 1;
            }
            else if (addition == '季宁人像') {
                this.additionType = 2;
            }
            else if (addition == '手持手机展示照片') {
                this.additionType = 3;
            }
            this.currentItem = this.itemTemp;
            this.currentRole = '我';
            this.currentWord = this.oldItemTemp.options[this.oldOptionIndexTemp].description;
            this.currentFakeWord = this.currentWord;
            this.currentExpression = this.oldItemTemp.expression;
            if (addition == '') {
                that.peopleConversion(that.currentExpression, 1);
                that.boxOneStatus = 'showBox';
                setTimeout(function () {
                    that.msgCharacter = 0;
                    that.getLetterByLetter($('#talkBoxContent1'));
                }, 200);
                setTimeout(function () {
                    that.clickable = true;
                    that.optionClick = false;
                }, 1700);
            }
            else if (addition == '语音播放') {
                that.telephoneStatus = 'showBox';
                setTimeout(function () {
                    that.step = 11;
                    that.clickable = true;
                    that.optionClick = false;
                }, 1000);
            }
            else if (addition == '季宁人像') {
                that.peopleConversion('季宁', 1);
                that.boxOneStatus = 'showBox';
                setTimeout(function () {
                    that.msgCharacter = 0;
                    that.getLetterByLetter($('#talkBoxContent1'));
                }, 200);
                setTimeout(function () {
                    that.step = 1;
                    that.additionType = 2;
                    that.clickable = true;
                    that.optionClick = false;
                }, 1700);
            }
            else if (addition == '手持手机展示照片') {
                that.telephoneStatus = 'showBox';
                setTimeout(function () {
                    that.step = 21;
                    that.clickable = true;
                    that.optionClick = false;
                }, 1000);
            }
            that.reviewBtnStatus = 'showBox';
        }
        else {
            this.step = 0;
            this.currentItem = this.questions[0];
            this.currentRole = '秦飞';
            this.currentExpression = this.currentItem.expression;
            this.currentWord = this.currentItem.description;
            this.currentFakeWord = this.currentWord;
            this.currentOptions = this.currentItem.options.sort(function () {
                return 0.5 - Math.random();
            });
            that.informationStatus = 'showInformation';
            that.reviewBtnStatus = 'showBox';
            setTimeout(function () {
                that.clickable = true;
            }, 200);
        }
        this.conversationHistory.unshift({
            'role': '店长笔记',
            'comment': '实体店的经营状况面临不少问题，包括物流配送、营销、客户服务等等。<br/>当务之急是要解决影响最严重的问题。<br/><br/>我要两周内解决物流问题：<br/>1.热门产品补给慢<br/>2.“送到家“延误严重<br/><br/>Sticky Note:<br/>约时间和物流主管秦飞见面！',
            'type': 9,
            'mode': 0
        }, {
            'role': '人物介绍',
            'comment': '秦飞：物流部主管<br/><br/>&nbsp;-&nbsp;在公司物流部门已工作八、九年，一手创建了现在的物流体系。<br/>&nbsp;-&nbsp;做事稳扎稳打，循序渐进，不喜欢太激进的做法。<br/>&nbsp;-&nbsp;擅长抓大放小，喜欢说：“做事情要看大局嘛！最重要的资源当然要放在最能产生价值的事情上”。<br/>&nbsp;-&nbsp;电商经验丰富，但是实体门店？很抱歉，没做过。<br/>&nbsp;-&nbsp;善交际、口碑好。特别是在线部门，一直称赞秦飞团队配合度很高。<br/>&nbsp;-&nbsp;最近是线上旺季，物流部门很忙。你约了秦飞两星期，他才和同意你见面。',
            'type': 9,
            'mode': 0
        });
    };
    CasePracticeInfluenceMainComponent.prototype.onOptionMouseDown = function (i, event) {
        if (this.optionClick == true || this.optionOnClick == true) {
            return false;
        }
        var that = this, pressing = $(event.target).children('.pressing'), // 选项背景进度div
        pressingOption = pressing.children('.pressingOption'), // 选项背景进度div中的文字
        pressingWidth = $(event.target).width(), // 选项宽度
        pressingHeight = $(event.target).height(), // 选项高度
        pressingOuterHeight = $(event.target).outerHeight(), // 选项真实高度, 包括margin, padding
        pressingOffset = $(event.target).offset(); // 选项在屏幕的位置
        // 按选项少于0.45s, 则不响应
        this.optionClick = false;
        this.optionOnClick = true;
        // 设置选项动画参数
        pressingOption.width(pressingWidth);
        pressingOption.height(pressingHeight);
        pressing.width(0);
        pressing.height(pressingOuterHeight),
            pressing.show();
        pressing.offset({ top: pressingOffset.top, left: pressingOffset.left });
        // 选项背景动画
        pressing.animate({
            width: $(event.target)[0].clientWidth
        }, this.type ? 300 : 500, 'linear');
        // 按中选项到达0.45s, 响应出现动画,  跳入下一个页面
        this.optionClickTimeout = setTimeout(function () {
            // 长按响应
            that.optionClick = true;
            // 设置下一页面参数
            // that.currentRole = '我';
            // that.currentComment = that.currentNode.option[i].multi_option_comment;
            // 隐藏背景色
            pressing.animate({ width: 0 }, 1);
            pressing.hide();
            // 进入选中按钮动画
            that.currentWord = that.currentOptions[i].description;
            that.currentOptions[i].description = '';
            $(event.target).addClass('optionLongPress');
            // 按键之后的动画
            $(event.target).find('.loading').fadeIn(200);
            // 隐藏文字
            // 其他按钮的消失时间, 设置比选中按钮timeout时间长500ms, 维持按钮相对位置
            that.apiService.answerExerciseQuestion('' + that.currentCaseId + '', that.currentItem.id, that.currentOptions[i].id).subscribe(function (practice) {
                //全局缓存最后提交数据
                var exerciseConfig = {
                    questionId: that.currentItem.id,
                    optionId: that.currentOptions[i].id,
                    exercisesId: that.currentCaseId
                };
                window['exercises' + that.currentCaseId] = exerciseConfig;
                that.currentFakeWord = that.currentWord;
                that.conversationHistory.push({
                    'role': '我',
                    'comment': that.currentWord
                });
                $('.optionItem').not($(event.target)).fadeOut(2500);
                // 保持选中按钮动画2s, 跳转动画
                setTimeout(function () {
                    // 移出按钮动画
                    $(event.target).removeClass('optionLongPress');
                    // that.step = 2.5;
                    // that.apiService.answerExerciseQuestion("" + that.currentCaseId + "", that.currentItem.id, that.currentOptions[i].id).subscribe(practice => {
                    that.clickable = false;
                    that.nextQuestionId = that.currentOptions[i].nextQuestionId;
                    that.setCurrentItem(that.nextQuestionId);
                    that.optionWrapStatus = 'hideOptionWrap';
                    if (that.currentOptions[i].addition == '') {
                        setTimeout(function () {
                            that.peopleConversion(that.currentExpression, 1);
                            that.boxOneStatus = 'showBox';
                            setTimeout(function () {
                                that.msgCharacter = 0;
                                that.getLetterByLetter($('#talkBoxContent1'));
                            }, 200);
                            setTimeout(function () {
                                that.step = 1;
                                that.additionType = 0;
                                that.clickable = true;
                                that.optionClick = false;
                            }, 1700);
                        }, 500);
                    }
                    else if (that.currentOptions[i].addition == '语音播放') {
                        console.log('语音播放');
                        setTimeout(function () {
                            that.telephoneStatus = 'showBox';
                            setTimeout(function () {
                                that.step = 11;
                                that.clickable = true;
                                that.optionClick = false;
                            }, 1000);
                        }, 500);
                    }
                    else if (that.currentOptions[i].addition == '季宁人像') {
                        console.log('季宁人像');
                        setTimeout(function () {
                            that.peopleConversion('季宁', 1);
                            that.boxOneStatus = 'showBox';
                            setTimeout(function () {
                                that.msgCharacter = 0;
                                that.getLetterByLetter($('#talkBoxContent1'));
                            }, 200);
                            setTimeout(function () {
                                that.step = 1;
                                that.additionType = 2;
                                that.clickable = true;
                                that.optionClick = false;
                            }, 1700);
                        }, 500);
                    }
                    else if (that.currentOptions[i].addition == '手持手机展示照片') {
                        console.log('手持手机展示照片');
                        setTimeout(function () {
                            that.telephoneStatus = 'showBox';
                            setTimeout(function () {
                                that.step = 21;
                                that.clickable = true;
                                that.optionClick = false;
                            }, 1000);
                        }, 500);
                    }
                    // });
                }, 2000); // end of second setTimeout
            });
        }, 450); // end of first setTimeout
    }; //end of onOptionMouseDown
    CasePracticeInfluenceMainComponent.prototype.onOptionMouseUp = function (event) {
        var _this = this;
        this.optionOnClick = true;
        setTimeout(function () {
            _this.optionOnClick = false;
        }, 300);
        // 如果已经触发按钮事件, 忽略放松按钮行为
        if (this.optionClick == true) {
            return true;
        }
        var pressing = $(event.target).children('.pressing');
        // 调整宽度为0
        setTimeout(function () {
            clearTimeout(_this.optionClickTimeout);
            pressing.stop().animate({
                width: 0
            }, 300, 'linear');
        }, this.type ? 300 : 0);
    };
    CasePracticeInfluenceMainComponent.prototype.getSelectedOptionIndex = function (options) {
        var temp = -1;
        options.forEach(function (item, index) {
            if (item.selected) {
                temp = index;
            }
        });
        return temp;
    };
    CasePracticeInfluenceMainComponent.prototype.setCurrentItem = function (questionId) {
        var that = this;
        this.questions.forEach(function (item, index) {
            if (item.id == questionId) {
                that.currentItem = item;
                that.setCurrentProgress(that.currentItem);
                return;
            }
        });
    };
    CasePracticeInfluenceMainComponent.prototype.setCurrentProgress = function (currentItem) {
        var percent = Math.floor(100 / 29 * 100) / 100; //3.44
        this.progress += percent;
        console.log(this.progress);
        this.currentProgress = Math.round(this.progress);
        this.apiService.saveProgress({ exerciseId: this.exerciseId, progress: this.currentProgress }).subscribe();
    };
    CasePracticeInfluenceMainComponent.prototype.close = function ($event) {
        this.practiceMetaId = 9;
        $event.stopPropagation();
        var link = [this.learningPathId, this.practiceMetaId, 'case-practice-influence',];
        if (this.type) {
            this.router.navigate(link, { queryParams: { type: 'huatek' } });
        }
        else {
            this.router.navigate(link);
        }
        var exerciseMetaId = $('#exerciseMetaId').val();
        this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: '情景模拟', courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem('userId') }).subscribe(function (result) {
            console.log(result);
        });
        console.log(exerciseMetaId);
        this.commonService.sendPostMessage(1, 'isPractice' + 'Complete');
    };
    CasePracticeInfluenceMainComponent.prototype.setItemTemp = function (questionId) {
        var that = this;
        this.questions.forEach(function (item, index) {
            if (item.id == questionId) {
                that.oldItemTemp = that.itemTemp;
                that.oldOptionIndexTemp = that.optionIndexTemp;
                that.itemTemp = item;
                return;
            }
        });
    };
    CasePracticeInfluenceMainComponent.prototype.reviewTableClick = function ($event, i) {
        $event.stopPropagation();
        this.conversationHistory[i].mode = (this.conversationHistory[i].mode + 1) % 2;
    };
    CasePracticeInfluenceMainComponent.prototype.peopleConversion = function (expression, type) {
        var status;
        if (type == 0) {
            status = 'hidePeople';
        }
        else if (type == 1) {
            status = 'showPeople';
        }
        if (expression == '正常') {
            this.normalStatus = status;
        }
        else if (expression == '抗拒') {
            this.resistStatus = status;
        }
        else if (expression == '接受') {
            this.acceptStatus = status;
        }
        else if (expression == '冷漠') {
            this.indifferentStatus = status;
        }
        else if (expression == '为难') {
            this.awkwardStatus = status;
        }
        else if (expression == '季宁') {
            this.womanStatus = status;
        }
    };
    CasePracticeInfluenceMainComponent.prototype.reviewConversation = function ($event) {
        $event.stopPropagation();
        if (this.reviewBtnStatus == 'hideBox') {
            return;
        }
        $('#shade').fadeIn(50);
        $('#reviewBox').fadeIn();
        $('#closeBtn').fadeIn();
        this.clickable = false;
    };
    CasePracticeInfluenceMainComponent.prototype.playAudio = function ($event) {
        //阻止冒泡,音频二次播放
        $event.stopPropagation();
        if (this.audioPlayed) {
            return;
        }
        var playObj = $('#play');
        var playProcess = $('#playBarInner');
        //进度每次从 0 开始
        playProcess.stop().css('width', '0%');
        var that = this;
        this.audio = new Audio();
        this.audioPlayed = true;
        this.audio.src = 'assets/audio/complain.wav';
        this.audio.play();
        //播放过程不允许跳过
        that.clickable = false;
        playObj.attr('src', '../../assets/picture/casepracticeinfluence/pause.png');
        this.audio.addEventListener('playing', function () {
            playProcess.animate({ width: '100%' }, 19000);
        });
        this.audio.addEventListener('ended', function () {
            that.clickable = true;
            that.step = 1;
            that.additionType = 1;
            //播放结束后可以继续播放
            that.audioPlayed = false;
            playObj.attr('src', '../../assets/picture/casepracticeinfluence/play.png');
        });
    };
    CasePracticeInfluenceMainComponent.prototype.closeTip = function ($event) {
        $event.stopPropagation();
        $('#shade').fadeOut();
        $('#reviewBox').fadeOut();
        $('#closeBtn').fadeOut();
        this.clickable = true;
    };
    CasePracticeInfluenceMainComponent.prototype.linkToReport = function () {
        var _this = this;
        if (this.buttonStatus == 'hideBox') {
            return;
        }
        this.apiService.finishExercise('' + this.currentCaseId + '').subscribe(function (practice) {
            _this.apiService.getKasInfos(_this.exerciseId, _this.practiceId).subscribe(function (result) {
                console.log(111111, result);
                if (result) {
                    _this.apiService.getLevelInfo(result.reports[0]);
                }
            });
            // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':localStorage.getItem('learningPathMetaId'),'module':'退出情景模拟1'}).then();
            var link = ['case-practice-report-new', _this.practiceId, _this.exerciseId, _this.learningPathId];
            if (_this.type) {
                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
            }
            else {
                _this.router.navigate(link);
            }
            var exerciseMetaId = $('#exerciseMetaId').val();
            _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: '情景模拟', courseUnit: '', type: 2, btnName: exerciseMetaId, userId: localStorage.getItem('userId') }).subscribe(function (result) {
                console.log(result);
            });
            console.log(exerciseMetaId);
            _this.commonService.sendPostMessage(2, 'isPractice' + 'Complete');
        });
    };
    CasePracticeInfluenceMainComponent.prototype.getLetterByLetter = function (container) {
        //container.html(this.currentWord);
        //return false;
        var that = this;
        this.letterClick = true;
        this.currentContainer = container;
        this.msgTimeout = setTimeout(function () {
            that.msgCharacter++;
            var type = that.currentWord.substring(0, that.msgCharacter);
            container.html(type);
            that.getLetterByLetter(container);
            if (that.msgCharacter == that.currentWord.length) {
                that.letterClick = false;
                clearTimeout(that.msgTimeout);
            }
        }, 30);
        // end of setTimeout
    }; // end of getLetterByLetter
    CasePracticeInfluenceMainComponent.prototype.showFullText = function (container) {
        var that = this;
        setTimeout(function () {
            that.letterClick = false;
        }, 750);
        clearTimeout(this.msgTimeout);
        container.html(this.currentWord);
    }; // end of showFullText
    CasePracticeInfluenceMainComponent.prototype.hideTip2 = function () {
        $('#shade2').fadeOut();
        $('#tip2').fadeOut();
    };
    CasePracticeInfluenceMainComponent.prototype.try = function () {
        $('body').css('height', '100%');
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    CasePracticeInfluenceMainComponent.prototype.returnList = function () {
        if (!this.practiceMetaId) {
            this.practiceMetaId = 9;
        }
        var link = [this.learningPathId, this.practiceMetaId, 'case-practice-influence'];
        this.router.navigate(link);
    };
    return CasePracticeInfluenceMainComponent;
}());
export { CasePracticeInfluenceMainComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-main/case-practice-influence-main.component.ts.pre-build-optimizer.js